import type { EmbeddedPromptParentOut } from '@repo/api-codegen';
import { baseQueryHooksFactory } from '../../factories';
import { aiEmbeddedQueryKeyFactory } from './constants';

const {
	useAIEmbedded,
	useAIEmbeddedInfiniteList,
	useAIEmbeddedList,
	useDeleteAIEmbedded,
	useUpdateAIEmbedded,
} = baseQueryHooksFactory<EmbeddedPromptParentOut, 'aIEmbedded'>(
	'aIEmbedded',
	aiEmbeddedQueryKeyFactory
);

export {
	useAIEmbedded,
	useAIEmbeddedInfiniteList,
	useAIEmbeddedList,
	useDeleteAIEmbedded,
	useUpdateAIEmbedded,
};
